import React, { useEffect, useRef } from 'react';
import block from 'bem-cn';
import { Route, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

import { StatisticModule } from 'modules/Statistic';
import { MyStatisticModule } from 'modules/MyStatistic';
import { GeneralReportModule } from 'modules/GeneralReport';

import { actions as authAction } from './features/Auth';
import Notify from 'features/notify/view';
import CreateUser from './features/users/view/CreateUser';
import UsersList from './features/users/view/UsersList';
import UserEdit from './features/users/view/UserEdit';
// import ChangePas from './features/changePas';
// import { Tree } from './features/tree';
import { Total } from './features/Total';
import SlotsHistory from 'features/slotsHistory/view/mobile';

import TransactionHistory from 'features/transaction/view/TransactionHistory';
// import { Locale } from 'features/locale';
import { Auth } from 'features/Auth';
import { actions as appActions } from 'features/app';
// import ActiveRequests from 'features/transaction/view/ActiveRequests/ActiveRequests';
import WithdrawalHistory from 'features/transaction/view/WithdrawalHistory/WithdrawalHistory';
import BithidePayment from 'features/payment/view/BithidePayment';
import SuAdminPayment from 'features/payment/view/SuAdminPayment';
import SuccesMessage from 'features/payment/view/SuccesMessage';
import BithidePaymentInfo from 'features/payment/view/BithidePayment/BithidePaymentInfo';
import PaymentHistory from 'features/payment/view/PaymentHistory/PaymentHistory';
import { Notifications } from 'features/notifications';
import FrameRedirectHandler from 'features/payment/view/FrameRedirectHandler';
import CashiersTournament3 from 'features/promotions/cashiersTournament3';

// import Footer from 'components/Footer';
import Header from 'components/Header';
// import HeaderBanner from 'components/HeaderBanner';
import AsyncPollNotifications from 'components/AsyncPoll/AsyncPollNotifications';

// import Subheader from 'components/Subheader';
// import Menu from 'components/Menu';
import SlideOut from 'components/SlideOut';

import { SlideOutModel } from 'shared/models/SlideOutModel';
import { ROLE_CASHIER } from 'shared/utils/roleBasedLocale';

import './App.scss';
import SuperadminBonusSistem from 'features/promotions/SuperadminBonusSistem/widgets/SuperadminBonusSistem/SuperadminBonusSistem';

const b = block('app');

const App = () => {
  // const locale = useSelector(state => state.locale.locale);
  const isAuth = useSelector(state => state.auth.isAuth);
  const role = useSelector(state => state.auth.role);
  const dispatch = useDispatch();
  const appRef = useRef(null);

  useEffect(() => {
    dispatch(authAction.checkAuth());
  }, [dispatch]);

  useEffect(() => {
    const touchListener = new SlideOutModel(value => dispatch(appActions.changeSideMenuOpened(value)), appRef.current);

    touchListener.init();
  }, [dispatch]);

  return (
    <div className={b()} ref={appRef}>
      <Notify />
      <Notifications />
      {isAuth && (
        <SlideOut>
          <Header />
          <div className={b('content')}>
            <Switch>
              <Route exact key="/user-create" path="/user-create" component={CreateUser} />
              {/* <Route exact key="/locale" path="/locale" component={Locale} /> */}
              <Route exact key="/users-list" path="/users-list" component={UsersList} />
              {/* <Route exact key="/" path="/">
                <Menu />
                <Footer locale={locale} isAuth={isAuth} />
              </Route> */}
              <Route exact key="/total" path="/total" component={Total} />
              <Route exact key="/bet-history" path="/bet-history" component={SlotsHistory} />
              <Route exact key="/user-edit/:id" path="/user-edit/:id" component={UserEdit} />
              <Route exact key="/transaction-history" path="/transaction-history" component={TransactionHistory} />
              {/* <Route exact key="/change-pas" path="/change-pas" component={ChangePas} /> */}
              {/* <Route exact key="/tree" path="/tree" component={Tree} /> */}
              {/* <Route exact key="/active-requests" path="/active-requests" component={ActiveRequests} /> */}
              <Route exact key="/withdrawal-history" path="/withdrawal-history" component={WithdrawalHistory} />
              <Route exact key="/payment/bithide" path="/payment/bithide" component={BithidePayment} />
              <Route
                exact
                key="/payment/bithide/:paymentId"
                path="/payment/bithide/:paymentId"
                component={BithidePaymentInfo}
              />
              <Route exact key="/paymentSuAdmin" path="/paymentSuAdmin" component={SuAdminPayment} />
              <Route exact key="/payment/payment-history" path="/payment/payment-history" component={PaymentHistory} />
              <Route exact key="/payment-result" path="/payment-result" component={SuccesMessage} />
              {role >= ROLE_CASHIER && (
                <Route exact path="/cashiers-tournament" component={CashiersTournament3} />
              )}
              <Route exact path="/payment-frame-redirect" component={FrameRedirectHandler} />
              <Route exact path="/superadmin-bonus-sistem" component={SuperadminBonusSistem} />
              {StatisticModule}
              {MyStatisticModule}
              {GeneralReportModule}
              <Redirect to="/users-list" />
            </Switch>
          </div>
        </SlideOut>
      )}
      {!isAuth && <Auth />}
      <AsyncPollNotifications />
    </div>
  );
};

export default App;
